import axios from "axios";
import env from "environment";

export default async function getSoilIndexByState(stateName, soilMap) {
  const dtn = await axios({
    method: "post",
    url: env.REACT_APP_DTN_SOIL_URL,
    timeout: 30000,
    data: {
      clus: soilMap.data,
      stateName,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });

  return dtn.data;
}
